import { Component, OnInit, TemplateRef, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NO_AVATAR_URL, MONITORIAS_MAIN_VIEW_URL, MONITORIAS_MAIN_HOME_URL, TUTORIAL_URL } from '../constants';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap';

import { environment } from '../../environments/environment';

import { AuthService, SessionProgramMonitoriaService } from 'auth-monitorias-uniandes';
import { LoginService } from '../login.service';

import { LoginModel } from './login.model';
import { PersonModel } from '../shared/models/person.model';
import { UserModel } from '../shared/models/user.model';

declare var jquery: any; declare var $: any;

@Component({
  selector: 'monitorias-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],

})

export class LoginComponent implements OnInit {

  //Estado del login
  UNAUTH = 0;
  LOADING = 1;
  AUTH = 2;

  // Atributo get que indica si se usa el login compacto
  compact = false;

  // Atributo get que indica si se muestra logout
  showLogout = false;

  // Atributo get que indica si se redirecciona a Academia cuando hay login exitoso o cierre de sesión
  redirect = false;

  //Atributo get que indica si se añade un botón de "Ir a Academia" cuando un usuario se encuentra logeado en el sistema. Util para un login externo.
  external = false;

  // Atributo que indica que tipo de perfil va a mostrar en el login compacto
  profile = "";

  //Modelo de login (para enviar en el request de login)

  loginModel: LoginModel = new LoginModel();

  //Usuario activo 
  currentUser: UserModel;

  //Persona activa
  currentPerson: PersonModel;

  //Pefil activo 
  currentProfile: string;

  /** 
   * Icono de avatar en el estado
  */
  avatar: ArrayBuffer | string;

  /**
  * Variable que persiste el estado actual del login
  */
  //Current Role
  currentRole = "";

  // Variable que persiste el estado actual del login
  authState = this.UNAUTH;

  /**
   * Variable que indica si hubo error de login (para subrayar de rojo el login en caso de error) 
   */
  loginError = false;

  //Flag para habilitar autenticación federada
  fedAuthEnabled = false;

  /**
   * ModalRef 
   */
  modalRef: BsModalRef;

  constructor(
    private loginService: LoginService,
    private authService: AuthService,
    private route: ActivatedRoute,
    private modalService: BsModalService,
    private cd: ChangeDetectorRef,
    private sessionProgramService: SessionProgramMonitoriaService
  ) {
    this.fedAuthEnabled = environment.federatedAuth;

  }

  ngOnInit() {
    //this.authState = this.AUTH;
    //this.currentUser = {'userName': 'jj.alarcon10', 'roles': ['ADMINISTRATOR']}

    this.route.queryParams.subscribe(params => {
      if (params['compact'] != null) {
        this.compact = true;
      }

      if (params['redirect'] != null) {
        this.redirect = true;
      }

      if (params['external'] != null) {
        this.external = true;
      }

      if (params['showLogout'] != null) {
        this.showLogout = true;
      }

      if (params['profile'] != null) {
        this.profile = params['profile'];
      }

      if (this.compact) {
        this.getCurrentSession();
      }
    });
  }

  doLogin() {
    this.sessionProgramService.deleteCurrentProgram();
    this.authState = this.LOADING;
    this.cd.detectChanges();
    this.loginService.doLogin(this.loginModel).subscribe(data => {

      if (this.redirect) {
        this.doMonitoriasRedirect(data);
      } else {
        this.onCurrentUserObtained(data);
        this.loginError = false;
        this.loginModel.pwd = "";
      }
    }, error => {
      this.loginModel.pwd = "";
      this.authState = this.UNAUTH;
      this.loginError = true;
      this.cd.detectChanges();
    });


  }

  doLogout() {
    this.authState = this.LOADING;
    this.loginService.doLogout().subscribe(data => {
      this.authService.deleteCurrentUserInLS();
      this.sessionProgramService.deleteCurrentProgram();
      this.authState = this.UNAUTH;
      this.currentUser = undefined;
      if (this.redirect) {
        this.doLogoutRedirect();
      }
    })
  }

  doMonitoriasRedirect(currentUser: any) {
    if (currentUser.roles.includes("ADMINISTRATOR")) {
      window.top.location.href = window.location.origin + MONITORIAS_MAIN_HOME_URL;
    } else if (currentUser.roles.includes("COORDINATOR")) {
      window.top.location.href = window.location.origin + MONITORIAS_MAIN_HOME_URL;
    } else if (currentUser.roles.includes("PROFESSOR")) {
      window.top.location.href = window.location.origin + MONITORIAS_MAIN_HOME_URL;
    } else if (currentUser.roles.includes("STUDENT")) {
      window.top.location.href = window.location.origin + MONITORIAS_MAIN_HOME_URL;
    } else if (currentUser.roles.includes("FINANCIAL_MANAGER")) {
      window.top.location.href = window.location.origin + MONITORIAS_MAIN_HOME_URL;
    } else if (currentUser.roles.includes("AGREEMENT_ADMINISTRATOR")) {
      window.top.location.href = window.location.origin + MONITORIAS_MAIN_HOME_URL;
    } else if (currentUser.roles.includes("AGREEMENT_APPROVER")) {
      window.top.location.href = window.location.origin + MONITORIAS_MAIN_HOME_URL;
    } else if (currentUser.roles.includes("ACCOUNT_PLAYABLE")) {
      window.top.location.href = window.location.origin + MONITORIAS_MAIN_HOME_URL;
    } else {
      window.top.location.href = window.location.origin + MONITORIAS_MAIN_VIEW_URL;
    }
    }

  doRefresh() {
    window.location.reload(true);
  }

  doLogoutRedirect() {
    window.top.location.href = window.location.origin;

  }

  resetErrorAlert() {
    this.loginError = false;
  }

  getCurrentSession() {
    this.authState = this.LOADING;
    this.loginService.getCurrentUserPerson().subscribe((returnData: any[]) => {
      this.onCurrentUserObtained(returnData);
    }, error => {
      this.authState = this.UNAUTH;
    });
  }

  onCurrentUserObtained(returnData: any[]) {
    this.currentUser    = returnData[0];
    this.currentPerson  = this.returnPerson(returnData[0], returnData[1]);
    this.currentProfile = this.profile !== "" && this.currentUser.roles.includes(this.profile) ? this.profile : this.currentUser.roles[0];
    this.loginService.getPhoto(this.currentUser.userName).subscribe(blob => {
      let reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onload = () => {
        this.avatar = reader.result;
        this.authService.saveCurrentUserInLS(this.currentUser);
        this.authState = this.AUTH;
      }
    }, error => {
      this.onErrorImg();
    });
  }

  returnPerson(user: UserModel, arrayPerson: PersonModel[]): PersonModel {
    for (let index = 0; index < arrayPerson.length; index++) {
      const itemPerson: PersonModel = arrayPerson[index];
      if (itemPerson.username === user.userName) {
        itemPerson.name = this.capitalizeText(itemPerson.name)
        itemPerson.lastName = this.capitalizeText(itemPerson.lastName)
        return itemPerson;
      }
    }
    return new PersonModel();
  }

  capitalizeText(text: string): string {
    return text.toLowerCase().replace(/\s([a-zA-Z0-9])|\s([^a-zA-Z0-9])|^([A-Z])|^([^a-zA-Z0-9])/g, function (letter) {
      return letter.toUpperCase();
    });
  }

  onErrorImg() {
    this.avatar = NO_AVATAR_URL;
  }

  onLoginInputChange() {
    this.loginError = false;
  }

  openModalLogin(template: TemplateRef<any>) {
    let ngbModalOptions: ModalOptions = {
      backdrop: 'static',
      keyboard: false,
      class: 'modal-m modal-dialog-centered'
    };
    this.modalRef = this.modalService.show(template, ngbModalOptions);
  }

  closeModalLogin() {
    this.modalRef.hide();
  }

  changeRole() {
    //this.currentUser.currentRole = this.currentRole;
    this.authService.saveCurrentUserInLS(this.currentUser);
  }

  openTutorial() {
    window.open(TUTORIAL_URL, '_blank');
  }

}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts